<script>
import PriceTable from './PriceTable.vue'
import DocumentProperties from './DocumentProperties.vue'
import FaqSearch from '@/components/faq/FaqSearch.vue'
export default {
  components: {
    PriceTable,
    DocumentProperties,
    FaqSearch
  },
  props: {
    headers: { type: Boolean },
    numbers: {
      type: Object,
      default() {
        return {
          1: Array.from({ length: 15 }, (_, i) => i + 1), // create array, begin with 1
          2: Array.from({ length: 14 }, (_, i) => i + 1),
          3: Array.from({ length: 4 }, (_, i) => i + 1),
          4: Array.from({ length: 4 }, (_, i) => i + 1)
        }
      }
    }
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    filteredNumbers() {
      if (!this.searchQuery) {
        return this.numbers
      }
      const result = {}
      for (const index in this.numbers) {
        const filteredItems = this.numbers[index].filter(n => {
          const title = this.$t(`faq.part${index}.title`).toLowerCase()
          const question = this.$t(`faq.part${index}.question${n}`).toLowerCase()
          const answer = this.$t(`faq.part${index}.answer${n}`).toLowerCase()
          const query = this.searchQuery.toLowerCase()
          return question.includes(query) || answer.includes(query) || title.includes(query)
        });

        if (filteredItems.length) {
          result[index] = filteredItems
        }
      }
      return result
    }
  },
  methods: {
    handleSearch(query) {
      this.searchQuery = query
    },
    highlightText(text) {
      if (!this.searchQuery) return text;

      const query = this.searchQuery.trim();
      if (!query) return text;

      // Escape RegEx Sonderzeichen im Suchbegriff
      const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    }
  }
}
</script>
<template>
  <div>
    <FaqSearch @search="handleSearch" />
  <v-expansion-panels>
    <div
      v-for="(item, index) in filteredNumbers"
      :key="index"
      class="v-item-group theme--light v-expansion-panels v-expansion-panels--focusable v-expansion-panels--popout" >
      <v-row v-if="headers"
      ><v-col>
        <h2 class="headline primary--text text--primary-2 pt-8 pb-4" v-html="highlightText($t(`faq.part${index}.title`))"></h2>
      </v-col>
      </v-row>
      <v-expansion-panel v-for="n in item" :key="n" class="background"
      ><v-expansion-panel-header>
        <h3
          class="font-weight-medium primary--text wordBreak"
          v-html="highlightText($t(`faq.part${index}.question${n}`))"
        ></h3></v-expansion-panel-header
      ><v-expansion-panel-content class="background-white"
      ><v-row class="pt-6 pb-2">
        <v-col><p v-html="highlightText($t(`faq.part${index}.answer${n}`))"></p></v-col>
      </v-row>
        <v-row justify="center">
          <v-col
            v-if="Number(index) === 1 && Number(n) === 3"
            cols="6"
            class="pb-6 px-md-12" >
            <PriceTable />
          </v-col>
          <v-col
            v-if="Number(index) === 2 && Number(n) === 3"
            class="pb-6 px-md-12" >
            <DocumentProperties
            /></v-col> </v-row></v-expansion-panel-content
      ></v-expansion-panel>
    </div>
  </v-expansion-panels>
  <v-row justify="center" class="mt-12 mb-8">
    <v-col cols="12" class="text-center">
      <p>
        {{ $t(`text.question.not.answered`) }}
        <a
          :href="`mailto:support@transactmail.de?subject=${$t('text.mailto.support.subject')}`"
          class="primary--text font-weight-medium">{{ $t(`text.contact.support`) }}
        </a>
      </p>
    </v-col>
  </v-row>
 </div>
</template>
<style lang="scss" scoped>
.background-white {
  background-color: white !important;
}
.background {
  background-color: var(--v-secondary) !important;
}
.v-expansion-panel:first-child {
  border-top: 1px solid;
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.v-expansion-panel--active {
  margin-top: 16px;
  margin-bottom: 16px;
}
.v-expansion-panel--active + .v-expansion-panel {
  margin-top: 0px;
}
a {
  text-decoration: underline;
}
</style>
